import React from 'react';
import './index.css'

interface ChipIndicatorProps {
  label: React.ReactElement | string
  counter?: any
  color?: string
  textColor?: string
  disabled?: boolean
  onClick?: () => void
}

const FilterChip: React.FC<ChipIndicatorProps> = ({ label, counter, color, textColor, disabled, onClick }) => {
  const defaultColor = '#8bed97';

  return (
    <div onClick={(onClick && !disabled) ? onClick : undefined}
      className={`filter-chip ${disabled ? 'disabled' : ''}`}
      style={{ backgroundColor: color ? color : defaultColor, color: textColor ? textColor : 'inherit' }}
    >
      {(counter >= 0) && (
        <div className='filter-chip_counter'>
          <span>{counter}</span>
        </div>
      )}
      <div className='filter-chip_label'>{label}</div>

    </div>
  );
}


interface ChipIndicatorOutlinedProps {
  label: React.ReactElement | string
  counter?: any
  active?: boolean
  disabled?: boolean
  onClick?: () => void
}

const FilterChipOutlined: React.FC<ChipIndicatorOutlinedProps> = ({ label, counter, active, disabled, onClick }) => {

  return (
    <div onClick={(onClick && !disabled) ? onClick : undefined} className={`filter-chip-outlined ${active ? 'active' : ''}`}>
      {(counter !== undefined) && (
        <div className={`filter-chip-outlined_counter ${active ? 'active' : ''}`}>
          <span>{counter}</span>
        </div>
      )}
      <div className='filter-chip-outlined_label'>{label}</div>
    </div>
  );
}

export default FilterChip;
export { FilterChipOutlined }